<div class="modal-header">
  <div>
    <h4 class="modal-title mb-0">SMS TAC Log</h4>
    <small class="text-muted" *ngIf="player_name">{{ player_name }} &bull; {{ mobile }}</small>
  </div>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body p-3">
  <div class="text-center py-4" *ngIf="is_loading">
    <div class="spinner-border"></div>
  </div>

  <div *ngIf="!is_loading && sms_list.length === 0" class="text-center py-4 text-muted">
    No SMS TAC records found for this player.
  </div>

  <div class="table-responsive" *ngIf="!is_loading && sms_list.length > 0">
    <table class="table table-sm table-hover table-bordered mb-0">
      <thead class="table-dark">
        <tr>
          <th style="width:40px">#</th>
          <th>Date / Time</th>
          <th>Mobile</th>
          <th>TAC</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sms of sms_list; let i = index">
          <td class="text-muted small">{{ i + 1 }}</td>
          <td class="small">{{ sms.timestamp | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
          <td>{{ sms.mobile }}</td>
          <td><span class="badge bg-secondary fs-6 letter-spacing-1">{{ sms.tac }}</span></td>
        </tr>
      </tbody>
    </table>
    <div class="text-muted small text-end pt-1">Showing {{ sms_list.length }} record(s)</div>
  </div>
</div>
